import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { Button } from "../../../components/Buttons";

export const StockBalance = () => {
    document.title = "Anbar qalığı";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Hesabatlar", value: "/reports" },
        { name: "Anbar qalığı", value: "/reports/stockbalance" },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Anbar qalığı</h2>
                    <p>
                        Anbar qalığı səhifəsi məhsulların anbarda olan sayı , mayası, satış qiymətinin göstəricisidir. Həmçinin, bir neçə anbar olduqda
                        məhsulları anbarlara görə çeşidləmək mümkündür
                        <br />
                        <Link to={""}>
                            <Button>Filter</Button>{" "}
                        </Link>
                        ilə müxtəlif meyarlara görə axtarış etmək üçün <Button>Axtar</Button> düyməsini sıxmaq lazımdır.
                    </p>
                    <img src="/images/reports/stockbalance.gif" alt="Anbar qalığı" />
                </article>
            </div>
        </div>
    );
};
